import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import type { RouteComponentProps } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { Radio, RadioGroup } from '@this/shared/ui/inputs/radio';
import MailSendLogsList from './mail_send_logs_list';
import MailBounce from './mail_bounce';

type TabType = 'logs' | 'bounce';

const MailSendLogs: React.FC<RouteComponentProps> = observer(({ history, location }) => {
  const search = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const activeTab = (search.get('tab') as TabType) || 'logs';

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value as TabType;
      history.push(`/arrangement/mail_send_logs?tab=${newValue}`);
    },
    [history]
  );

  useEffect(() => {
    document.title = 'メール送信ログ';
    return () => {
      document.title = '管理画面';
    };
  }, []);

  return (
    <>
      <Box m={2}>
        <RadioGroup layout="horizontal" name="mail-send-logs-tab" value={activeTab} onChange={handleChange}>
          <Radio value="logs">メール送信ログ</Radio>
          <Radio value="bounce">メール送信対象外</Radio>
        </RadioGroup>
      </Box>

      {activeTab === 'logs' && <MailSendLogsList />}
      {activeTab === 'bounce' && <MailBounce />}
    </>
  );
});

export default MailSendLogs;
